export default "__VITE_ASSET__BwMMQjNb__"